import React from 'react';
import Toast from './Toast/Toast';

interface SGToastsWrapperProps {
    notifications: any[];
}

export const ToastsWrapper = (props: SGToastsWrapperProps) => {
    const ERROR_NOTIFICATION_TYPE = 'notification-error';
    const ERROR_VARIANT = 'error';

    if (!props.notifications) {
        return <></>;
    }

    const convertVariant = (variant: string) => {
        return variant === ERROR_NOTIFICATION_TYPE ? ERROR_VARIANT : variant;
    };

    return (
        <div className="toasts-wrapper__container">
            {props.notifications.map((notification: any, index: number) => (
                <Toast
                    content={notification.content}
                    variant={convertVariant(notification.variant)}
                    key={index}
                    dismissed={notification.dismissed}
                />
            ))}
        </div>
    );
};
